export class ResetPasswordDto {
  public Email: string;
  public Code: string;
  public Password: string;
}
